import { Component } from '@angular/core';

@Component({
  selector: 'app-schedules',
  template: `<schedules-list></schedules-list>`,
})
export class SchedulesComponent {}
